import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=078aa022&scoped=true&lang=pug&"
import script from "./TableData.vue?vue&type=script&lang=ts&"
export * from "./TableData.vue?vue&type=script&lang=ts&"
import style0 from "./TableData.vue?vue&type=style&index=0&id=078aa022&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078aa022",
  null
  
)

export default component.exports